export default [
  // $api['hooks/productConfig']()
  {
    name: 'ProductConfig',
    value: {
      dms: {
        renewSwitch: 1,
        sellSwitch: 1,
        upgradeSwitch: 1,
      },
      iplc: {
        renewSwitch: 1,
        upgradeSwitch: 1
      },
      cs: {
        sellSwitch: 1
      },
      csUnlimited: {
        sellSwitch: 1
      }
    }
  }
]
